// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--dKJnW","footerInner":"footer-module--footer-inner--LgpY4","footerColumn":"footer-module--footer-column--3c9zZ"};